import { Typography } from "@heroui/react";

import { formatDateTime } from "@/utils/date";

/**
 * Plain spans, not Typography: these are dropped inside table-cell Typography
 * (`{row.name ?? <EmptyRowValue />}`), and Typography always renders a <p> -
 * a <p> inside a <p> is invalid HTML and hydration-errors on every table.
 */
export const EmptyRowValue = ({ value = "N/A" }: { value?: string }) => {
  return <span className="text-muted text-sm">{value}</span>;
};

export const EmptyDash = () => (
  <span className="text-muted text-sm">&mdash;</span>
);

export const DateRowValue = ({ value }: { value: string }) => {
  const formatted = formatDateTime(value);

  return (
    <Typography className="truncate" type="body-sm">
      {formatted}
    </Typography>
  );
};
